/**
 * OpenXRRenderModelManager registration: the parser. It reuses the Node3D parse, and property knowledge lives
 * in linterParser.ts. Its Godot effect needs a live XR session the previewer does not run (ADR-0045), so
 * index.r3f.ts registers Node3D as `pending` and its children still land in the right
 * transform space.
 */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseNode3D } from '../../../base/node3d/parser';
const openXRRenderModelManagerRegistration = {
    typeName: 'OpenXRRenderModelManager',
    parser: parseNode3D,
};
nodeRegistry.register(openXRRenderModelManagerRegistration);
//# sourceMappingURL=index.js.map